import { render } from "./AboutMedals.vue?vue&type=template&id=46d206e2"
import script from "./AboutMedals.vue?vue&type=script&lang=js"
export * from "./AboutMedals.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__